import type { CSSProperties } from 'react';
import { cn } from '@/lib/utils';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

const TOOLTIP_TEXT =
  "It's easy to get overwhelmed by everything you could be doing. The Weekly One is your most important next step, distilled. Commit to one thing each week, follow through, and watch the progress compound.";

interface WeeklyOneInfoTooltipProps {
  iconClassName?: string;
  style?: CSSProperties;
}

export function WeeklyOneInfoTooltip({ iconClassName = 'text-muted-foreground', style }: WeeklyOneInfoTooltipProps) {
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="What is the Weekly One?"
          style={style}
          className="inline-flex items-center justify-center focus:outline-none focus-visible:ring-1 focus-visible:ring-ring rounded shrink-0"
        >
          <Info className={cn('w-[14px] h-[14px]', iconClassName)} aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="max-w-[280px] text-xs leading-relaxed"
      >
        {TOOLTIP_TEXT}
      </TooltipContent>
    </Tooltip>
  );
}
